<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import './assets/fontawesome/css/all.css';
#app {
  font-family: 'DIN-medium', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.fa, .fas, .far, .fal, .fad, .fab{
  line-height: inherit !important;
}
.fade-enter-active{
    transition: opacity .5s;
}
.fade-leave-active{
    transition: opacity .5s;
}
.fade-enter-from, 
.fade-leave-to{
    opacity: 0;
}

</style>
